import { useTranslation } from "react-i18next";

import { useAtiraFormContext } from "../context/form-context";
import { ActivityTab } from "../../../components/activity-timeline/ActivityTab";
import { Drawer } from "../../../components/Drawer";

export const FormActivityModal: React.FC = () => {
  const { t } = useTranslation();

  const {
    selectedForm: currentForm,
    formActivityVisible,
    setFormActivityVisible,
  } = useAtiraFormContext();

  if (!currentForm) {
    return null;
  }

  return (
    <Drawer
      key={currentForm._id}
      open={formActivityVisible}
      onClose={() => setFormActivityVisible(false)}
      title={`${t("forms.read.modal.title")}: ${currentForm.title}`}
      size={"large"}
    >
      <ActivityTab entity={currentForm || {}} />
    </Drawer>
  );
};
